<section class="grid audience-mock-bar">
	<section class="d-flex flex-wrap justify-content-around align-items-center">
		<div class="col-3 text-16-bold">Audience Dev Tool</div>
		<div class="col-6">
			<div class="text-12 text-md-12 text-sm-12">Select Country</div>
			<label class="full-width">
				<select [(ngModel)]="countryMock || defaultCountry" (change)="onCountrySelection($event)">
					<option *ngFor="let country of listOfCountries" [value]="country"> {{ country }}</option>
					<option value="clear">Clear Mock</option>
				</select>
			</label>
		</div>
		<div class="col-4 text-12">
			Current ViewCategory: <strong>{{ viewCategory }}</strong>
		</div>
		<div class="col-8 text-12">
			Current Audience: <strong>{{ audience | json }}</strong>
		</div>
	</section>
</section>
